import { Progress } from "@/components/ui/progress";
import { CheckCircle2, XCircle, Lock, Unlock } from "lucide-react";

export const ReadinessChecklist = ({ readiness, onSelectPhase }) => (
  <div className="rounded-lg border border-slate-200 bg-white p-4" data-testid="erp-readiness-checklist">
    <div className="flex items-center justify-between gap-4">
      <div>
        <p className="overline">ERP Readiness Gate</p>
        <h3 className="text-base font-semibold text-slate-900 flex items-center gap-2">
          {readiness.ready ? <><Unlock className="h-4 w-4 text-emerald-600" /> Ready for ERP Handover</> : <><Lock className="h-4 w-4 text-slate-500" /> Locked — {readiness.total - readiness.resolved} phase(s) unresolved</>}
        </h3>
      </div>
      <div className="text-right">
        <div className="text-2xl font-bold font-mono text-slate-900" data-testid="erp-readiness-pct">{readiness.pct}%</div>
        <div className="text-[10px] text-slate-500">{readiness.resolved}/{readiness.total} resolved</div>
      </div>
    </div>
    <Progress value={readiness.pct} className="mt-3 h-1.5" />
    <ul className="mt-4 divide-y divide-slate-100">
      {readiness.checklist.map((c) => (
        <li key={c.phase_id} className="py-2" data-testid={`readiness-item-${c.phase_id}`}>
          <button onClick={() => onSelectPhase(c.phase_id)} className="flex items-start gap-2 text-left w-full hover:bg-slate-50 rounded px-1">
            {c.resolved ? <CheckCircle2 className="h-4 w-4 text-emerald-600 mt-0.5 shrink-0" /> : <XCircle className="h-4 w-4 text-red-500 mt-0.5 shrink-0" />}
            <div className="min-w-0">
              <div className="text-sm text-slate-900">{c.phase} <span className="text-xs text-slate-400 capitalize">· {c.status.replace(/_/g, " ")}</span></div>
              {c.missing.length > 0 && <ul className="text-xs text-slate-500 mt-0.5 space-y-0.5">{c.missing.map((m, i) => <li key={i}>– {m}</li>)}</ul>}
            </div>
          </button>
        </li>
      ))}
    </ul>
  </div>
);
